import axios from '@fs/zion-axios'
import { trackEvent } from '@fs/zion-analytics'

function updateMemberStatus(groupId, memberCisId, status) {
  return axios.post(`/service/tree/tree-data/groups/${groupId}/members/by-id/${memberCisId}`, { status })
}

export function removeMemberAsAdmin(groupId, memberCisId) {
  return updateMemberStatus(groupId, memberCisId, 'MEMBER').then(() => trackEvent({ link_name: 'Remove as Admin' }))
}

export function assignMemberAsAdmin(groupId, memberCisId) {
  return updateMemberStatus(groupId, memberCisId, 'ADMIN').then(() => trackEvent({ link_name: 'Assign as Admin' }))
}
